import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';
import { ALL_LANGUAGES, DEFAULT_LANGUAGE } from './tolgee/shared';

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ALL_LANGUAGES,

  // Used when no locale matches
  defaultLocale: DEFAULT_LANGUAGE,
});

// read more about next-intl library
// https://next-intl-docs.vercel.app
export const { Link, redirect, usePathname, useRouter } = createNavigation(routing);
